import React from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router'
import {Link} from 'react-router-dom'

const BreadCrumb = ({
    location,
    endpoint,
    endpointList//this value is from the store
}) => {
    
  

    let locationPathArray = location.pathname.split("/")
    locationPathArray.shift()
    let endpointName = locationPathArray[0].charAt(0).toUpperCase() + locationPathArray[0].substring(1)
    endpointName = endpointName.split('-').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join('-')
    let listId = locationPathArray[1]
    let breadCrumbArray = [endpointName]
    
    //GET TASK NAME
    var taskList = endpointList[0] 

    if(listId==="new"){
        breadCrumbArray.push("New")
    } else if ( listId && !isNaN( Number(listId) ) ){
        let listObj = endpoint ? endpoint.list.find(obj => obj.id === Number(listId)) : null
        
        var listArr = ['job-queues', 'message-queues']

        if(listArr.indexOf(locationPathArray[0]) ==  -1 ){
            if( listObj && listObj.name ){
                breadCrumbArray.push(listObj.name)
            }
        }else{
            if(listObj){
                var task = taskList.list.find(task => {
                    if(task.id == listObj.task_id){
                        
                        breadCrumbArray.push(task.name)
                    }
                    
                })
            }
        }
        
        // if( listObj && listObj.name ){
        //     breadCrumbArray.push(listObj.name)
        // } else if ( listObj && listObj.description ) {
        //     breadCrumbArray.push(listObj.description)
        // } else {
        //     breadCrumbArray.push(listId)
        // }
    }
    for( let i = 2; i < locationPathArray.length; i++ ){
        let breadCrumb = locationPathArray[i].charAt(0).toUpperCase() + locationPathArray[i].substring(1)
        breadCrumbArray.push(breadCrumb)
    }

    return (
        <div className="float-left breadcrumbs"> 
            <div className="">
                <p style={{marginTop: '3px'}}>
                    <Link to={'/'}><i className="fas fa-th"></i></Link> 
                    {
                        breadCrumbArray.map((breadCrumb,index) => {

                            let path = locationPathArray.slice(0,index+1).join("/")
                            return (
                                <span key={`breadcrumb-${index}`}>
                                <i className="fas fa-arrow-right"></i>
                                <Link to={`/${path}`}>{breadCrumb}</Link> 
                                </span>
                            )
                        })
                    }
                </p>
            </div>
        </div>
    )
}

function mapStateToProps (state){
    return {
        endpointList: state.endpoints
    }
}

export default withRouter(connect(mapStateToProps)(BreadCrumb))


// WEBPACK FOOTER //
// ./src/components/breadCrumb.js